import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useScreenSize } from '@/hooks';
import HelpCenter from './sections/HelpCenter';
import UserAgreement from './sections/UserAgreement';
import CoinAccuracyLimit from './sections/CoinAccuracyLimit';
import SupportHelp from './sections/SupportHelp';
import FeeComponent from './sections/FeeHelp';
import GoogleAuthenticatorComponent from './sections/GoogleAuthenticator';
import FAQComponent from './sections/FAQ';
import RegistrationAndLogin from './sections/RegisterAndLogin';
import CryptocurrencyInfo from './sections/CryptCurrencyInfo';
import PrivacyPolicyHelp from './sections/PrivacyPolicyHelp';
import HGSwap from './sections/HGSwapPolicy';
import TermsOfService from './sections/TermsOfServiceHelp';
import ProvidersHelp from './sections/ProvidersHelp';
import styles from './ProvablyFair.module.css';

/**
 * ProvablyFair Page Component
 * Help center with sidebar navigation and content sections
 * Similar to ibitplay ProvablyFair but using JACKOPOT design system
 */
const ProvablyFair = () => {
  const [activeSection, setActiveSection] = useState('Provably fair');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isMobile } = useScreenSize();

  const sideContentItems = [
    { name: 'Provably fair', component: HelpCenter },
    { name: 'User Agreement', component: UserAgreement },
    { name: 'Coin Accuracy Limit', component: CoinAccuracyLimit },
    { name: 'Support', component: SupportHelp },
    { name: 'Fee', component: FeeComponent },
    { name: 'Google Authenticator', component: GoogleAuthenticatorComponent },
    { name: 'FAQ', component: FAQComponent },
    { name: 'Cryptocurrency', component: CryptocurrencyInfo },
    { name: 'Privacy Policy', component: PrivacyPolicyHelp },
    { name: 'Registration and Lo...', component: RegistrationAndLogin },
    { name: 'Swap Policy', component: HGSwap },
    { name: 'Terms of Service', component: TermsOfService },
    { name: 'Providers', component: ProvidersHelp }
  ];

  const handleSectionChange = (section) => {
    setActiveSection(section);
    setIsMobileMenuOpen(false);
  };

  const ActiveComponent = sideContentItems.find(item => item.name === activeSection)?.component || (() => null);

  return (
    <div className={styles.container}>
      {/* Mobile Menu Button */}
      {isMobile && (
        <button 
          className={styles.mobileMenuButton}
          onClick={() => setIsMobileMenuOpen(true)}
        >
          <Menu size={20} />
          <span>{activeSection}</span>
        </button>
      )}

      <div className={styles.contentWrapper}>
        {/* Sidebar */}
        <div className={`${styles.sidebar} ${isMobileMenuOpen ? styles.sidebarOpen : ''}`}>
          {isMobile && (
            <div className={styles.sidebarHeader}>
              <span className={styles.sidebarTitle}>Help Center</span>
              <button
                className={styles.closeButton}
                onClick={() => setIsMobileMenuOpen(false)}
                aria-label="Close menu"
              >
                <X size={24} />
              </button>
            </div>
          )}
          
          <div className={styles.sidebarContent}>
            {sideContentItems.map(item => (
              <button
                key={item.name}
                className={`${styles.sidebarItem} ${activeSection === item.name ? styles.sidebarItemActive : ''}`}
                onClick={() => handleSectionChange(item.name)}
              >
                {item.name}
              </button>
            ))}
          </div>
        </div>

        {/* Main Content */}
        <div className={styles.mainContent}>
          <ActiveComponent />
        </div>
      </div>

      {/* Mobile Backdrop */}
      {isMobile && isMobileMenuOpen && (
        <div 
          className={styles.backdrop}
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </div>
  );
};

export default ProvablyFair;
